<mat-dialog-content>
  <div class="alert-content">
    <div>
      <div
        class="icon-container"
        *ngIf="data.config.confirm">
        <mat-icon
          class="icon_warning"
          [inline]="true">
          error_outline
        </mat-icon>
      </div>
      <div
        class="icon-container"
        *ngIf="data.config.icon&&!data.config.confirm">
        <mat-icon
          *ngIf="data.config.icon=='success'"
          class="icon_success"
          [inline]="true">
          check_circle_outline
        </mat-icon>

        <mat-icon
          *ngIf="data.config.icon=='error'"
          class="icon_error"
          [inline]="true">
          cancel
        </mat-icon>

        <mat-icon
          *ngIf="data.config.icon=='warning'"
          class="icon_warning"
          [inline]="true">
          error_outline
        </mat-icon>

        <mat-icon
          *ngIf="data.config.icon=='info'"
          class="icon_info"
          [inline]="true">
          info
        </mat-icon>

        <mat-spinner
          *ngIf="data.config.icon=='loading'"
          style="margin-bottom:10px;text-align: center;"
          [diameter]="35">

        </mat-spinner>
      </div>

      <h4
        class="mat-headline text-center text-title"
        *ngIf="data.title">{{data.title}}</h4>

      <h3
        class="mat-title text-center text-msg"
        *ngIf="data.msg">{{data.msg}}</h3>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions class="buttons-container">
  <button
    mat-flat-button
    color="primary"
    [disabled]="loading"
    (click)="handleClose(true)">
    <mat-spinner
      *ngIf="loading"
      color="primary"
      [diameter]="25"
      style="float:left"
      class="m-t-5 m-r-5">
    </mat-spinner>
    {{data.config.confirm?okConfirmText:okAlertText}}
  </button>

  <button
    color="primary"
    *ngIf="data.config.confirm"
    mat-stroked-button
    [disabled]="loading"
    (click)="handleClose()">
    {{cancelConfirmText}}
  </button>
</mat-dialog-actions>
